module.exports = __webpack_public_path__ + "img/pay_at_cashier.463eeb88.png";